/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'
import { DAYS, MONTHS, YEARS } from '../enums/DurationUnits.mjs'
import LeaseChargeSchema from './LeaseChargeSchema.mjs'

const LeaseSchema = new Schema({
  agencyFees: {
    type: 'number',
    min: 0,
    required: true
  },
  isAgencyFeesWithTax: {
    type: 'boolean',
    required: true
  },
  billingStartDate: {
    type: 'string',
    format: 'date-time'
    // min: (context) => context?.startDate
  },
  billingEndDate: {
    type: 'string',
    format: 'date-time'
    // min: (context) => context?.billingStartDate || context?.startDate,
    // max: (context) => context?.endDate
  },
  entryInventoryDate: {
    type: 'string',
    format: 'date-time'
  },
  exitInventoryDate: {
    type: 'string',
    format: 'date-time'
  },
  LeaseCharges: {
    type: 'array',
    required: true,
    items: {
      type: LeaseChargeSchema
    }
  },
  duration: {
    type: 'number',
    min: 0,
    required: true
  },
  durationUnit: {
    type: 'string',
    allowed: [YEARS, MONTHS, DAYS],
    required: true
  },
  endDate: {
    type: 'string',
    format: 'date-time'
    // min: (context) => context?.noticeDate || context?.startDate
  },
  equipped: {
    type: 'boolean',
    required: true
  },
  estateId: {
    type: 'number',
    required: true
  },
  furnished: {
    type: 'boolean',
    required: true
  },
  lessorId: {
    type: 'number',
    required: true
  },
  mandateId: {
    type: 'number',
    required: true
  },
  managed: {
    type: 'boolean',
    required: true
  },
  managementFees: {
    type: 'number',
    min: 0
  },
  isManagementFeesWithTax: {
    type: 'boolean',
    required: true
  },
  noticeDate: {
    type: 'string',
    format: 'date-time'
    // min: (context) => context?.startDate
  },
  noticeDuration: {
    type: 'number',
    min: 0,
    max: 365,
    required: true
  },
  noticeDurationUnit: {
    type: 'string',
    allowed: [YEARS, MONTHS, DAYS],
    required: true
  },
  paymentDay: {
    type: 'number',
    min: 1,
    max: 28,
    required: true
  },
  // reference: {
  //   type: 'string',
  //   maxLength: 20,
  //   required: true,
  // },
  rent: {
    type: 'number',
    min: 0,
    required: true
  },
  renewalDate: {
    type: 'string',
    format: 'date-time',
    required: true
  },
  startDate: {
    type: 'string',
    format: 'date-time',
    required: true
  },
  tenantId: {
    type: 'number',
    required: true
  },
  securityDeposit: {
    type: 'number',
    min: 0,
    required: true
  },
  templateId: {
    type: 'number',
    required: true
  },
  tmpRef: {
    type: 'string'
  }
})

export default LeaseSchema
